export class LeadReport {
    FromDate: Date;
    ToDate: Date;
    ZoneID: number;
    UserID: number;
    DealerID: number;
    DealerSEID: number;
}
